module.exports = __webpack_public_path__ + "static/media/1.a59b1f0a.JPG";